export default __webpack_public_path__ + "static/media/presence-management.9f3e64fe.png";